export const actions = {
  set_state: 'google_tag_manager/set_state',
  get_google_tag_manager: 'google_tag_manager/get',
  get_with_qr: 'google_tag_manager/get_with_qr',
  delete_google_tag_manager: 'google_tag_manager/delete',
  create_google_tag_manager: 'google_tag_manager/create'
}
